/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-01-07 11:21:56
 * @LastEditors: K
 * @LastEditTime: 2022-08-16 17:08:42
 */
import { serviceDelay } from '../models/serviceDelay'
import { ADMIN_API_PREFIX, API_PREFIX } from './constant'
import { Request } from './request'

export interface ServiceDelayParams {
  tenantId: string
  type?: number
  value?: number
  startTime?: number
  endTime?: number
}

export function getDelay(body: ServiceDelayParams): Request {
  return {
    url: `${API_PREFIX}/blade-administer/tenant/delay`,
    method: 'POST',
    body,
  }
}
// 订单管理-新增订单-是否显示开始结束时间
export interface getTimeShowFnParams {
  tenantId?: string
  productId?: string

}
export function getTimeShowFn(params: getTimeShowFnParams): Request {
  return {
    url: `${API_PREFIX}/blade-administer/m/order/getTimeStatus`,
    method: 'GET',
    params,
  }
}

// 合作平台
export function PlatformIdList(params: {
  current: number
  size: number
}): Request {
  return {
    url: `${API_PREFIX}/blade-administer/m/sysplatform/list`,
    method: 'GET',
    params,
  }
}



// 获取服务结束时间接口
export interface GetTenantServerEndTimeParams {
  tenantId: number
  productId: number
}

export function getTenantServerEndTime(params: GetTenantServerEndTimeParams): Request {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/m/order/getTenantServerEndTime`,
    method: 'GET',
    params,
  }
}